/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { HomefieldColorSwatchComponent } from './color-swatch.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HomefieldColorSwatchComponent],
  exports: [HomefieldColorSwatchComponent],
})
export class HomefieldColorSwatchModule {}
